module.exports = __webpack_public_path__ + "img/icon-03-subscriptionAsset 9.73d11022.svg";